import Content from './content';
import { useTranslation } from '@CS/hooks';
import CSS from './ResponseError.module.css';
import type { ResponseErrorInfo } from '@/services/api/types';
import { type PopupProps, Popup } from '@CS/components/Popups';

type ResponseErrorProps = PopupProps & {
  info?: ResponseErrorInfo;
};

export const ResponseError = ({ info = {}, ...props }: ResponseErrorProps) => {
  const { title, retry } = useTranslation(Content);
  const { code, error, message } = info;

  return (
    <Popup {...props}>
      <div className={CSS.descriptionContainer}>
        <h2>{(!code && error) || title}</h2>

        {(code || message) && (
          <div className={CSS.errorDescription}>
            {code && (
              <strong>
                {code && `${code}${error ? ': ' : ''}`}
                {error}
              </strong>
            )}

            <span>{message}</span>
          </div>
        )}

        <em>{retry}</em>
      </div>
    </Popup>
  );
};
